import { Box, CardMedia, Icon, Typography } from '@mui/material'
import React from 'react'
import defaultImage from 'assets/images/default_avatar.png'
import PFeedbackModal from '../../performance-result/components/PFeedbackModal'
import { useQuery, useQueryClient } from 'react-query'
import { getSubmission } from 'services/api/modules/performance/appraisal/submission'
import { useEffect } from 'react'

const ReviewersCard = ({ reviewerDetails, status }) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.invalidateQueries('getFeedback')
    queryClient.resetQueries('getFeedback')
  }, [])

  const { data } = useQuery(
    ['getFeedback', reviewerDetails?.submission_id, 'feedback'],
    async () => {
      const { data } = await getSubmission(reviewerDetails?.submission_id)
      return data
    }
  )

  return (
    <Box
      height="calc(100vh - 75px)"
      bgcolor="white.main"
      boxShadow="0px 0px 10px lightgray"
      position="sticky"
      top={75}
    >
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        gap={2}
        borderBottom="solid 1px"
        borderBottomColor="gray-line.main"
        px={5}
        py={3}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={60}
          height={60}
          borderRadius="50%"
          backgroundColor={reviewerDetails?.score ? 'light-yellow-01.main' : 'gray-background.main'}
        >
          <Icon
            sx={
              reviewerDetails?.score
                ? {
                    color: 'yellow-01.main',
                    fontSize: '30px',
                  }
                : {
                    color: 'gray-inactive-button.main',
                    fontSize: '30px',
                  }
            }
          >
            workspace_premium
          </Icon>
        </Box>
        <Box>
          <Typography variant="h2" fontWeight="bold">
            {reviewerDetails?.score ? Math.round(reviewerDetails?.score * 50) / 10 : '--'}
          </Typography>
          <Typography color="light-gray-text.main">Score</Typography>
        </Box>
      </Box>
      {!!reviewerDetails?.reviewer_name && (
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          gap={2}
          borderBottom="solid 1px"
          borderBottomColor="gray-line.main"
          px={5}
          py={3}
        >
          <Typography color="light-gray-text.main">Reviewer</Typography>
          <Box display="flex" gap={2}>
            <CardMedia
              component="img"
              sx={{
                height: 60,
                width: 60,
                objectFit: 'cover',
                borderRadius: '50%',
              }}
              src={reviewerDetails?.reviewer_image ? reviewerDetails?.reviewer_image : defaultImage}
            />
            <Box display="flex" flexDirection="column" justifyContent="center">
              <Typography noWrap>{reviewerDetails?.reviewer_name}</Typography>
              <Typography color="light-gray-text.main" variant="body2">
                {reviewerDetails?.reviewer_department_name}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}

      {/* Feedback section */}
      {reviewerDetails?.reviewee_name !== reviewerDetails?.reviewer_name &&
      data?.submission_feedback === null ? (
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          py={3}
          sx={{
            position: 'absolute',
            bottom: 0,
          }}
        >
          <PFeedbackModal submissionId={reviewerDetails?.submission_id} status={status} />
        </Box>
      ) : reviewerDetails?.reviewee_name !== reviewerDetails?.reviewer_name &&
        data?.submission_feedback ? (
        <Box px={5} py={3}>
          <Typography color="light-gray-text.main" mb={1}>
            My feedback
          </Typography>
          <Typography>{data?.submission_feedback}</Typography>
        </Box>
      ) : null}
    </Box>
  )
}

export default ReviewersCard
